import { Container, Row } from "reactstrap";
import LoginWithTooltipContainer from "../../Componant/Authentication/LoginWithTooltip";

const LoginWithTooltip = () => {
  return (
    <Container fluid>
      <Row>
        <LoginWithTooltipContainer />
      </Row>
    </Container>
  );
};

export default LoginWithTooltip;
